<template>
  <v-container fluid>
    <b-row>
      <b-col cols="12">
        <b-col xs12>
          <h2>Nuovo Preventivo</h2>
        </b-col>
        <b-row style="background-color: orange">
          <b-col sm="12" lg="4">
            <b-form-input
              id="input-nominativo"
              v-model="nominativo"
              placeholder="Nominativo"
              required
            ></b-form-input>
          </b-col>
          <b-col sm="12" lg="3">
            <b-form-datepicker
              id="dal-datepicker"
              v-model="dal"
              class="mb-2"
            ></b-form-datepicker>
          </b-col>
          <b-col sm="12" lg="3">
            <b-form-datepicker
              id="al-datepicker"
              v-model="al"
              class="mb-2"
            ></b-form-datepicker>
          </b-col>
          <b-col lg="2">
            <b-button @click="addoccupancy">Inizia</b-button>
          </b-col>
        </b-row>
          <b-row style="background-color: orange">
            <b-col cols="5">
              <b-row>Adulti</b-row>

              <b-button @click="occupancy.nadulti--">
                <v-icon>mdi-minus</v-icon>
              </b-button>

              {{ occupancy.nadulti }}

              <b-button @click="occupancy.nadulti++">
                <v-icon>mdi-plus</v-icon>
              </b-button>
            </b-col>
            <b-col cols="5">
              Bambini
              <h3>
                <b-button @click="occupancy.nbambini--">
                  <v-icon>mdi-minus</v-icon>
                </b-button>
                {{ occupancy.nbambini }}
                <b-button @click="occupancy.nbambini++">
                  <v-icon>mdi-plus</v-icon>
                </b-button>
              </h3>
              <v-text-field
                v-for="i in occupancy.nbambini"
                :key="i"
                :label="`eta ${i}`"
                v-model="occupancy.etabambini[i - 1]"
              />
            </b-col>

            <b-col cols="1">
              <b-button @click="addoccupancy">Aggiungi</b-button>
            </b-col>
          </b-row>
      </b-col>
      <b-col lg="3" sm="12">
        <b-col style="background-color: green" fluid>
          
          <b-row style="background-color: purple">
            <b-col cols="6" v-for="n in occupancies" :key="n">
              <v-card min-height="80">
                <v-card-text>
                  <h6>
                    {{ n.nadulti }} Adulti
                    <v-icon>mdi-face</v-icon>
                  </h6>
                  <h6>
                    {{ n.nbambini }} Bambini
                    <v-icon>mdi-baby</v-icon>
                  </h6>
                  <b-col sm12>
                    <v-select
                      v-model="n.trattamento"
                      :items="trattamenti"
                      item-value="id"
                      item-text="descrizione"
                    ></v-select>
                  </b-col>
                  <v-card-actions>
                    <b-button fab small @click="deloccupancy(n)">
                      <v-icon>mdi-minus</v-icon>
                    </b-button>
                    <b-button fab small @click="calcoccupancy(n)">
                      <v-icon>mdi-engine</v-icon>
                    </b-button>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </b-col>
          </b-row>
          <b-row style="background-color: yellow">
            <!--<b-col cols="12">Proposta corrente: {{this.propostacorrente}}</b-col>-->
            <b-col cols="12">Disponibilita</b-col>
            <b-col v-for="p in disponibilta.Prodotto" :key="p.Id" cols="12">
              <div class="card">
                <div class="card-body">
                  <b-row justify-center>
                    <b-col cols="8">
                      <span>{{ p.Descrizione }}</span>
                      <span>{{ p.NumRisDispo }}</span>
                      <span>Disponibili</span>
                    </b-col>
                    <b-col>
                      <b-button v-for="item in trattamenti" :key="item.id">{{
                        item.descbreve
                      }}</b-button>
                    </b-col>
                    <b-col cols="2">
                      <h6>{{ p.PrezzoProd }} €</h6>
                    </b-col>
                    <b-col cols="1">
                      <b-button fab @click="addcamera(p)">
                        <v-icon>mdi-plus</v-icon>
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col cols="3" v-for="n in 3" :key="n"></b-col>
          </b-row>
        </b-col>
      </b-col>
      <b-col  style="background-color: grey">
        Proposte
        <b-button color="success" @click="addproposta">
          <v-icon>mdi-plus</v-icon>
        </b-button>
        <b-col v-for="n in proposte" :key="n">
          <b-card
            @click="selezionaproposta(n)"
            min-height="100"
            :color="n == propostacorrente ? 'green' : 'grey'"
          >
            <v-card-text>
              <h2>Proposta {{ n.id }}</h2>
              <h6>Camere         <b-button color="success" >
          <v-icon>mdi-plus</v-icon>
        </b-button></h6>
              <div v-for="k in n.camere" :key="k">
                <b-row>
                  <b-col>
                <v-icon>mdi-bed</v-icon>
                {{ k.Descrizione }} - {{ k.PrezzoProd }}€
                </b-col>
                <b-col>
                
                <label for="adulti">Adulti</label>
                    <select class="form-control" id="adulti">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                  </b-col>
                  <b-col>
                  <label for="bambini">Bambini</label>
                      <select class="form-control" id="bambini">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                  </b-col>
                  <b-col>
                    <b-button color="success" >
                      <v-icon>mdi-engine</v-icon>
                    </b-button>
                  </b-col>
                  <b-col>
                    <b-button color="success" >
                      <v-icon>mdi-pencil</v-icon>
                    </b-button>
                  </b-col>
                  </b-row>
              </div>
              <h3 class="text-right">€ {{ CalcolaTotaleProposta(n) / 100 }}</h3>
            </v-card-text>
            <v-card-actions>
              <b-button fab small>
                <v-icon>mdi-minus</v-icon>
              </b-button>
            </v-card-actions>
          </b-card>
        </b-col>
      </b-col>

      <b-col cols="1" style="background-color: white">
        <b-row v-if="propostacorrente">
          <b-col cols="12" v-if="propostacorrente.camere">
            Numero Camere <b>{{ propostacorrente.camere.length }}</b>
          </b-col>
          <b-col cols="6">
            <v-text-field label="Prezzo Listino" />
          </b-col>
          <b-col cols="6">
            <v-text-field label="Prezzo Vendita" />
          </b-col>
          <b-col cols="12">
            <v-textarea
              v-model="propostacorrente.annotazioni"
              label="Annotazioni"
            />
          </b-col>
          <b-col cols="12">
            Servizi Aggiuntivi
            <b-row>
              <b-col cols="2" v-for="i in 10" :key="i">
                <v-checkbox :label="`Servizio ${i}`"> </v-checkbox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      dal: null,
      al: null,
      nominativo: null,
      menudal: false,
      menual: false,
      trattamento: null,
      occupancy: { nadulti: 1, nbambini: 0, etabambini: [] },
      occupancy_default: {
        nadulti: 1,
        nbambini: 0,
        etabambini: [],
        trattamento: null,
      },
      arrangiamenti: [{ id: "BB" }, { id: "HB" }, { id: "FB" }],
      proposte: [],
      occupancies: [],
      propostacorrente: {},
      disponibilta: {
        Prodotto: [
          {
            Id: 58,
            Descrizione: "Standard",
            DescrizioneAggiuntiva: "",
            Condizione: "",
            PrezzoRis: 0,
            PrezzoOsp: 0,
            PrezzoProd: 60,
            IdTrattamento: "",
            NumAduMax: 3,
            NumAduMin: 1,
            NumBamMax: 2,
            NumBamMin: 0,
            OccupazioneStd: 2,
            IdGestionale: 405256,
            IdGestionaleGruppo: "",
            LinkImmagine: "",
            NumRisDispo: 8,
          },
          {
            Id: 57,
            Descrizione: "Suite",
            DescrizioneAggiuntiva: "",
            Condizione: "",
            PrezzoRis: 0,
            PrezzoOsp: 0,
            PrezzoProd: 80,
            IdTrattamento: "",
            NumAduMax: 3,
            NumAduMin: 1,
            NumBamMax: 2,
            NumBamMin: 0,
            OccupazioneStd: 2,
            IdGestionale: 405257,
            IdGestionaleGruppo: "",
            LinkImmagine:
              "https://www.hotelbernard.it/wp-content/uploads/sites/33/HB_suite1-75-2.jpg",
            NumRisDispo: 4,
          },
        ],
      },
    };
  },
  computed: {
    trattamenti() {
      return []; //this.$store.state.strutture.data[this.$store.state.strutturacorrente].trattamenti
    },
  },
  methods: {
    addproposta() {
      var p = {
        id: this.proposte.length,
        camere: [],
        disponibilta: Object.assign({}, this.disponibilta),
      };
      this.proposte.push(p);
      this.selezionaproposta(p);
    },
    CalcolaTotaleProposta(p) {
      let tot = 0;
      p.camere.forEach((element) => {
        tot += element.PrezzoProd;
      });
      //const x = p.camere.reduce(function(pv, cv) { return pv.PrezzoProd + cv.PrezzoProd }, 0)
      return tot;
    },
    addoccupancy() {
      console.log(Object.assign({}, this.occupancy));
      this.occupancies.push(Object.assign({}, this.occupancy));
      this.occupancy = Object.assign({}, this.occupancy_default, {
        etabambini: new Array(),
      });
      this.occupancy.trattamento = this.trattamento;
    },
    addcamera(camera) {
      console.log(camera);
      if (this.proposte.length == 0) {
        this.addproposta();
      }
      this.propostacorrente.camere.push(camera);
    },
    selezionaproposta(proposta) {
      this.propostacorrente = proposta;
    },
    deloccupancy(n) {
      console.log(JSON.stringify(n));
    },
    calcoccupancy(n) {
      const occ = {
        Comando: "GetElencoDisponibilitaProd",
        Dal: this.formatDate(this.dal),
        Al: this.formatDate(this.al),
        Adulti: n.nadulti,
        Bambini: n.nbambini,
        EtaBambini: n.etabambini,
        Trattamento: n.trattamento,
        ConPrezzi: "1",
      };
      this.$store.dispatch("APIRequestHR", occ).then((r) => {
        console.log("RISP", r);
        if (r.data.RISPOSTAOK == -1) {
          this.disponibilta = r.data.RISULTATOJSON.Dispo;
        }
      });

      console.log(n);
      /*
      this.disponibilta.Prodotto.forEach(element => {
        element.PrezzoProd += 14;
      });
      */
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}${month}${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>